import { render, staticRenderFns } from "./CreateClaimReviewAndSubmit.vue?vue&type=template&id=19919969"
import script from "./CreateClaimReviewAndSubmit.vue?vue&type=script&lang=js"
export * from "./CreateClaimReviewAndSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports